import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { Table } from 'primeng/table';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Grupo } from 'src/app/admihair/api/dto/grupo';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { EmpresaService } from 'src/app/admihair/service/empresa.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';

@Component({
  selector: 'app-usuario-listar',
  templateUrl: './usuario-listar.component.html',
  styleUrls: ['./usuario-listar.component.scss']
})
export class UsuarioListarComponent implements OnInit {

  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  loading: boolean = false;
  loadingUsuarios: boolean = false;
  grupos: Grupo[] = [];
  empresas: Empresa[] = [];
  usuarios: Usuario[] = [];

  constructor(private usuarioService: UsuarioService,
    private erroService: ErroService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,) { }

  @ViewChild('filter') filter!: ElementRef;

  ngOnInit(): void {
    this.loadingUsuarios = true;
    this.listarUsuarios();
  }

  listarUsuarios(){
    this.usuarioService.listarTodos().subscribe({
      next: (data: Usuario[]) => {
        this.loadingUsuarios = false;
        this.usuarios = data;
      },
      error: (err: any) => {
        this.loadingUsuarios = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    });
  }

  editar(id: number){
    this._router.navigate(["/rfarias/usuario/editar/" + id], { relativeTo: this._activatedRoute })
  }

  detalhar(id: number){
    this._router.navigate(["/rfarias/usuario/detalhar/" + id], { relativeTo: this._activatedRoute })
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
